export default __webpack_public_path__ + "static/Swiss721BT-Bold-70e4cdc96ba49e858d623cb647e5b8cf.woff2";